import { RadioGroup } from "../parts/RadioGroup";
import { ActionItem } from "../parts/ActionItem";
import { CheckboxGroup } from "../parts/CheckboxGroup";
import { SubMenuGroup } from "../parts/SubMenuGroup";
import { MenuLabelItem } from "../parts/MenuLabel";
import { SeparatorItem } from "../parts/Separator";
import { DropdownMenuItem } from "../types";

export const renderMenuItem = (
  menuItem: DropdownMenuItem,
  keyIndex: number,
) => {
  switch (menuItem.type) {
    case "ActionMenuItem":
      return <ActionItem key={`item-${keyIndex}`} actionItem={menuItem} />;
    case "CheckboxGroup":
      return (
        <CheckboxGroup key={`item-${keyIndex}`} checkboxGroupItem={menuItem} />
      );
    case "RadioGroup":
      return <RadioGroup key={`item-${keyIndex}`} radioGroupItem={menuItem} />;
    case "SubMenuItem":
      return <SubMenuGroup key={`item-${keyIndex}`} subMenuItem={menuItem} />;
    case "MenuLabel":
      return <MenuLabelItem key={`item-${keyIndex}`} menuItem={menuItem} />;
    case "Separator":
      return <SeparatorItem key={`item-${keyIndex}`} />;
    default:
      return null;
  }
};
